
import {
    DeleteIconsOptions,
    DownloadIcon,
    IconClip
} from '../../../../../../../components/buttons/IconButtons';
import { CustomTextField } from './../../../../../../../components/CustomTextField';
import { FILE_TYPE } from '../../../../../../../Helpers/fileType';
import React from "react";
import CustomPhotoPickerMultiple from "../../../../../../../components/PhotoPicker/CustomPhotoPickerMultiple";
import {fileSize} from "../../../../../../../constant/variable";
import {useTranslation} from "react-i18next";
/**
 *
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : FullStack Developer
 * @Email : kpozos@ibl.mx
 *
 */
const PeriodReviewDetailsSection = ({
    periodReviewItem,
    emptyFields,
    handleChange,
    photoPicker,
    setPhotoPicker
}) => {
    const {t} = useTranslation();
    return (
        <>
            <div className={'d-flex align-items-center m-3'}>
                <IconClip className='h-24px w-24px' />
                <p className='fs-14px font-color-general-950 ibl-font-w-600 ml-2'>
                    {t('justification_evidence')}
                </p>
            </div>
            <div className={'border-bottom-shades-300'} />
            <div className='row justify-content-center m-3'>
                <p className='fs-14px font-color-general-950 ibl-font-w-600 mb-3 text-center'>
                    {t('provide_reason_manual_adjustment')}
                </p>
                <CustomTextField
                    id='txt_upr_description'
                    name='description'
                    value={periodReviewItem.description}
                    trans='description'
                    required={true}
                    emptyFields={emptyFields}
                    onChange={handleChange}
                    multiline={true}
                    row={4}
                />
                <p className='fs-14px font-color-general-950 ibl-font-w-600 mb-3 text-center'>
                    {t('attach_evidence_optional')}
                </p>

                <CustomPhotoPickerMultiple
                    id='fp_upr_evidence'
                    photoPickerFile={photoPicker}
                    setPhotoPickerFile={setPhotoPicker}
                    accept={{ ...FILE_TYPE.FILES, size: fileSize }}
                    showBtnDeleteItemGallery={true}
                    showBtnCamera={false}
                    deleteIcon={DeleteIconsOptions}
                    downloadIcon={DownloadIcon}
                    showBtnDownload={true}
                    apiDelete={false}
                />
            </div>
        </>
    );
};

export default PeriodReviewDetailsSection;
